<template>
    <div class="row align-items-end">
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Plaka</label>
            <v-select-list v-model="plate" placeholder="Plaka Seçiniz" label="PlateValue" :options="plates" />
        </div>

        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Filo</label>
            <v-select-list v-model="filo" placeholder="Filo Seçiniz" label="Description" :options="fleets" />
        </div>

        <div class="col-auto mb-1 mb-md-0">
            <button class="btn btn-secondary" v-on:click="setFilter">Filtrele</button>
        </div>
    </div>
</template>

<script>
import FuelOperationApi from "@/api/fuel-operations";
import VehicleOperationsApi from "@/api/vehicle-operations";
export default {
    data() {
        return {
            periods: [],
            fleets: [],
            plates: [],
            plateDefineStatuses: [
                { StatusLabel: "Tümü", StatusValue: null },
                { StatusLabel: "Evet", StatusValue: true },
                { StatusLabel: "Hayır", StatusValue: false },
            ],
            fleets: [],
            filter: {
                VehiclePlate: null,
                FiloCode: null,
            },
        };
    },
    mounted() {
        this.getPlates();
        this.getFleets();
    },
    methods: {
        getFleets() {
            FuelOperationApi.PetrolOfisi.FiloCode.List().then((res) => {
                this.fleets = res.data.Data;
            });
        },
        getPlates() {
            VehicleOperationsApi.Plate.ListAll().then((res) => {
                this.plates = res.data.Data;
            });
        },
        clearFilter() {
            this.filter.VehiclePlate = null;
            this.filter.FiloCode = null;
            this.$emit("filter", this.filter);
        },
        setFilter() {
            this.$emit("filter", this.filter);
        },
    },
    computed: {
        plate: {
            get: function () {
                return this.plates.find((s) => s.PlateValue == this.filter.VehiclePlate);
            },
            set: function (value) {
                this.filter.VehiclePlate = value?.PlateValue || null;
            },
        },
        filo: {
            get: function () {
                return this.fleets.find((s) => s.Code == this.filter.FiloCode);
            },
            set: function (value) {
                this.filter.FiloCode = value?.Code || null;
            },
        },
    },
};
</script>

<style></style>
